import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SidenavigationComponent } from 'src/sidenavigation/sidenavigation.component';
import { LoginComponent } from 'src/modules/login/login.component';
import { PreregisterComponent } from 'src/modules/preregister/preregister.component';
import { ExistingCustomerComponent } from 'src/modules/existingCustomer/existingCustomer.component';
import { LanguageComponent } from 'src/modules/language/language.component';
import { GuidedTourComponent } from 'src/modules/guided-tour/guided-tour.component';
import { VaChatPage } from './va/va-chat/va-chat.page';
import { ProspectUserComponent } from 'src/modules/prospectuser/prospectuser.component';
import { VerifyOtpComponent } from 'src/modules/verifyOtp/verifyOtp.component';
import { ConfirmRegisterComponent } from 'src/modules/confirmregister/confirmregister.component';
import { ForgotpasswordComponent } from 'src/modules/forgotpassword/forgotpassword.component';
import { ChangepasswordComponent } from 'src/modules/changePassword/changePassword.component';
import { FaqsPage } from './va/faqs/faqs.page';
import { AboutPage } from './va/about/about.page';
import { StarredPage } from './va/starred/starred.page';
import { SettingPage } from './va/setting/setting.page';
import { ProfilePage } from './va/profile/profile.page';
import { PopupconfigPage } from './va/popupconfig/popupconfig.page';
import { EmailchatPage } from './va/emailchat/emailchat.page';
import { BankformComponent } from 'src/modules/bankform/bankform.component';
import { DocumentDownload } from 'src/modules/documentdownload/documentdownload.component';
import { AadharUpdateComponent } from './va/aadharupdate/aadharupdate.component';
import { PanUpdateComponent } from './va/panupdate/panupdate.component';
import { AddressUpdateComponent } from './va/addressupdate/addressupdate.component';
import { EmailupdatePage } from './va/emailupdate/emailupdate.page';
import { MobileupdatePage } from './va/mobileupdate/mobileupdate.page';
import { CountryListModal } from './va/countrylistModal/countrylistModal.component';
import { FeedbackModal  } from './va/feedbackModal/feedbackModal.component';
import { HowtousePage } from './va/howtouse/howtouse.page';
import { NomineePage } from './va/nominee/nominee.page';
import { FreezeComponent } from 'src/modules/freezescreen/freezescreen.component';
import { ChangeFrequency } from './va/changefrequency/changefrequency.component';
import { ChangeDOB } from './va/changedob/changedob.component';
import { AuthGuard } from './gaurd/auth.guard';
import { UpdatenamePage } from './va/updatename/updatename.page';
import { UpdateappointeePage } from './va/updateappointee/updateappointee.page';
import { PagenotfoundComponent } from 'src/modules/pagenotfound/pagenotfound.component';
import { ClaimstatusComponent } from 'src/modules/claimstatus/claimstatus.component';
import { LinkpolicyComponent } from './va/linkpolicy/linkpolicy.component';
import { VideolistComponent } from './va/videolist/videolist.component';
import { DigitalcertificateComponent } from './va/digitalcertificate/digitalcertificate.component';
import { NotificationsComponent } from './va/notifications/notifications.component';
import { VasdetailsComponent } from './va/vasdetails/vasdetails.component';
import { ConsentpageComponent } from './va/consentpage/consentpage.component';
import { VasfaqPage } from './va/vasfaq/vasfaq.page';

const routes: Routes = [
  { path: '', redirectTo: 'language', pathMatch: 'full' },
  { path: 'language', component: LanguageComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard]   },
  { path: 'claim', component: ClaimstatusComponent, canActivate: [AuthGuard]   },
  { path: 'claimlogin', component: ClaimstatusComponent, canActivate: [AuthGuard]   },
  { path: 'loginva', component: LoginComponent, canActivate: [AuthGuard]  },
  { path: 'loginUnregister', component: LoginComponent, canActivate: [AuthGuard]  },
  { path: 'preRegister', component: PreregisterComponent, canActivate: [AuthGuard]  },
  { path: 'existingCustomer', component: ExistingCustomerComponent, canActivate: [AuthGuard]  },
  { path: 'register', component: ExistingCustomerComponent, canActivate: [AuthGuard]  },
  { path: 'prospregister', component: ExistingCustomerComponent, canActivate: [AuthGuard]  },
  { path: 'changelanguage', component: LanguageComponent, canActivate: [AuthGuard]  },
  { path: 'guideTour', component: GuidedTourComponent, canActivate: [AuthGuard]  },
  { path: 'prospectuser', component: ProspectUserComponent, canActivate: [AuthGuard]  },
  { path: 'verifyOtpVa', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyotppros', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyOtpReg', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyOtp', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyemailOtpupdate', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyOtpupdate', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'verifyOtpPassword', component: VerifyOtpComponent },
  { path: 'verifyOtpaddress', component: VerifyOtpComponent, canActivate: [AuthGuard]  },
  { path: 'confirmregister', component: ConfirmRegisterComponent, canActivate: [AuthGuard]  },
  { path: 'forgotpassword', component: ForgotpasswordComponent, canActivate: [AuthGuard]  },
  { path: 'changePassword', component: ChangepasswordComponent, canActivate: [AuthGuard]  },
  { path: 'forgotChangePassword', component: ChangepasswordComponent, canActivate: [AuthGuard]  },
  { path: 'about', component: AboutPage , canActivate: [AuthGuard] },
  { path: 'starred', component: StarredPage, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfilePage, canActivate: [AuthGuard]  },
  { path : 'bankform', component : BankformComponent, canActivate: [AuthGuard] },
  { path : 'documentdownload', component : DocumentDownload, canActivate: [AuthGuard] },
  { path : 'freezescreen', component : FreezeComponent, canActivate: [AuthGuard] },
  { path : 'pagenotfound', component : PagenotfoundComponent},
  { 
    path: 'va',
    children: [
      { path: '', redirectTo: 'chat', pathMatch: 'full' },
      { path: 'chat', component: VaChatPage, canActivate: [AuthGuard]  },
      { path: 'faqs', component: FaqsPage, canActivate: [AuthGuard]  },
      { path: 'setting', component: SettingPage, canActivate: [AuthGuard]  },
      { path: 'popupconfig', component: PopupconfigPage, canActivate: [AuthGuard]  },
      { path: 'emailchat', component: EmailchatPage, canActivate: [AuthGuard]  },
      { path : 'aadharForm', component : AadharUpdateComponent, canActivate: [AuthGuard] },
      { path : 'panForm', component : PanUpdateComponent, canActivate: [AuthGuard] },
      { path : 'addressForm', component : AddressUpdateComponent, canActivate: [AuthGuard] },
      { path: 'emailupdate', component: EmailupdatePage, canActivate: [AuthGuard]  },
      { path: 'updateemail', component: EmailupdatePage, canActivate: [AuthGuard]  },
      { path: 'mobileupdate', component: MobileupdatePage, canActivate: [AuthGuard]  },
      { path: 'updatemobile', component: MobileupdatePage, canActivate: [AuthGuard] },
      { path: 'nomineeForm', component: NomineePage, canActivate: [AuthGuard] },
      { path: 'howtouse', component: HowtousePage, canActivate: [AuthGuard] },
      { path: 'countrylist', component: CountryListModal, canActivate: [AuthGuard] },
      { path: 'feedback', component: FeedbackModal, canActivate: [AuthGuard]},
      { path: 'changefrequency', component: ChangeFrequency },
      { path: 'changedob', component: ChangeDOB },
      { path: 'updatename', component: UpdatenamePage },
      { path: 'updateappointee', component: UpdateappointeePage },
      { path: 'linkpolicy', component: LinkpolicyComponent, canActivate: [AuthGuard]   },
      { path: 'youtubevideo', component: VideolistComponent, canActivate: [AuthGuard]   },
      { path: 'dlc', component: DigitalcertificateComponent, canActivate: [AuthGuard]   },
      { path: 'notification', component: NotificationsComponent },
      { path: 'vasdetails', component: VasdetailsComponent, canActivate: [AuthGuard]   },
      { path: 'consentpage', component: ConsentpageComponent, canActivate: [AuthGuard]},
      { path: 'vasfaq', component: VasfaqPage, canActivate: [AuthGuard]}
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
